import { Component, signal, inject, ElementRef, HostListener } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TopNav } from "../top-nav/top-nav";
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { SearchInpComponent } from '../search-inp/search-inp.component';
import { FormsModule } from '@angular/forms';
import { PatronAuthService, PatronUser } from '../../core/services/patron-auth.service';

@Component({
  selector: 'app-nav',
  standalone: true,
  templateUrl: './nav.html',
  styleUrl: './nav.scss',
  imports: [TranslateModule, SearchInpComponent, CommonModule, TopNav, RouterLink, RouterLinkActive, FormsModule],
})
export class Nav {
  public isMobile$!: Observable<boolean>;
  showSearch = signal<boolean>(false);
  sections!: Observable<[]>;
  isMenuOpen = signal<boolean>(false);
  
  // Patron Auth State
  authService = inject(PatronAuthService);
  currentUser$: Observable<PatronUser | null> = this.authService.currentUser$;
  isAuthDropdownOpen = signal<boolean>(false);
  
  loginEmail = '';
  loginPassword = '';
  loginErrorKey = ''; // translation key, e.g. 'Nav.loginError.invalid'
  isLoading = false;

  constructor(public translate: TranslateService, private router: Router, public route: ActivatedRoute, private el: ElementRef) { }

  ngOnInit(): void {}

  /** Close dropdown when clicking outside the nav user area */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isAuthDropdownOpen() && !this.el.nativeElement.contains(event.target)) {
      this.isAuthDropdownOpen.set(false);
    }
  }
  toggleMenu() {
    this.isMenuOpen.set(!this.isMenuOpen());
  }

  toggleAuthDropdown() {
    this.isAuthDropdownOpen.set(!this.isAuthDropdownOpen());
    if (this.isAuthDropdownOpen()) {
      this.loginErrorKey = '';
      this.loginPassword = '';
    }
  }

  onLoginSubmit() {
    if (!this.loginEmail || !this.loginPassword) {
      this.loginErrorKey = 'Nav.loginError.required';
      return;
    }

    this.isLoading = true;
    this.loginErrorKey = '';

    this.authService.login(this.loginEmail, this.loginPassword).subscribe({
      next: () => {
        this.isLoading = false;
        this.isAuthDropdownOpen.set(false);
        this.loginPassword = '';
        this.loginEmail = '';
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 401 || err.status === 403) {
           this.loginErrorKey = 'Nav.loginError.invalid';
        } else {
           this.loginErrorKey = 'Nav.loginError.generic';
        }
      }
    });
  }

  logout() {
    this.authService.logout();
    this.isAuthDropdownOpen.set(false);
    window.location.reload();
  }

  onSearch(value: string | null, modelName?: string): void {
    this.showSearch.set(false);

    let searchTerm = value?.trim() || modelName?.trim();
    if (!searchTerm) {
      return;
    }

    this.router.navigate(
      ['/browse-index'],
      {
        queryParams: {
          q: searchTerm
        }
      }
    );
  }

  onTranslatedSearch(key: string) {
    this.showSearch.set(false);
    this.onSearch(null, key);
  }

  changeLanguage() {
    const lang = this.translate.getCurrentLang() === 'en' ? 'ar' : 'en';
    localStorage.setItem('koha_lang', lang);
    this.translate.use(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}

